import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import api from "../../../api/api";
import EditModal from "./EditModal";

const BookmarkList = () => {
  const [bookmarkList, setBookmarkList] = useState([]);
  const [del, setDel] = useState(false);
  const [bkId, setBkId] = useState(0);
  const [viewMore, setViewMore] = useState(true)


  useEffect(() => {
    api
      .get("/info/bookmarks/")
      .then((response) => {
        console.log(response.data);
        setBookmarkList(response.data);
      })
      .catch((error) => {
        toast.error("something went wrong");
      });
  }, [del]);

  const deleteBookmark = (id) => {
    api
      .delete(`/info/bookmarks/${id}/`)
      .then((response) => {
        console.log(response.data);
        setDel(!del);
      })
      .catch((error) => {
        toast.error("Unable to delete");
      });
  };


   const handleSearch = (e) => {
    api
      .get(`/info/bookmarks/?search=${e.target.value}`)
      .then((response) => {
        // console.log(response.data);
        setBookmarkList(response.data)
      })
      .catch((error) => {});
  };

  
  return (
    <div className="">
      <h1 className="text-primary-red mt-2 text-center text-3xl font-bold lg:!mt-6">
        Bookmark List
      </h1>
      <div className="">
        <img
          src="../../images/title-border.png"
          alt=""
          className="mx-auto mt-4"
        />
      </div>
      {/* table  */}
      <div className="mt-3 w-full md:px-10">
        <div className="flex flex-col">
          <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="inline-block min-w-full py-4 sm:px-6 lg:px-8">
              <div className="overflow-hidden">
                {/* search */}
                <input
                  type="text"
                  placeholder="Search by name "
                  id="table-search"
                  onChange={(e)=> handleSearch(e)}
                  className="mb-2 block w-80 rounded-lg border border-gray-700 bg-gray-50 py-2.5 px-3 text-sm focus:border-blue-500 focus:ring-blue-500"
                />
                <table className="min-w-full text-center">
                  <thead className="font-Bree bg-primary-red border-b font-bold">
                    <tr>
                      <th
                        scope="col"
                        className="px-6 py-4 text-sm font-medium text-white"
                      >
                        SN.
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-4 text-sm font-medium text-white"
                      >
                        Site Name
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-4 text-sm font-medium text-white"
                      >
                        Site Details
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-4 text-sm font-medium text-white"
                      >
                        Link
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-4 text-sm font-medium text-white"
                      >
                        Action
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-4 text-sm font-medium text-white"
                      >
                        Status
                      </th>
                    </tr>
                  </thead>
                  <tbody className="font-Acme">
                    {bookmarkList.length > 0 ? (
                      <>
                        
                        {bookmarkList?.slice(0, `${viewMore ? 2: bookmarkList.length}`).map((item, i) => (
                          <tr key={item.id} className="border-b  bg-white">
                            <td className="whitespace-nowrap px-6 py-4 text-sm font-light text-gray-900">
                              {i + 1}
                            </td>
                            <td className="whitespace-nowrap px-6 py-4 text-sm font-light text-gray-900">
                              {item.name}
                            </td>
                            <td className="whitespace-nowrap px-6 py-4 text-sm font-light text-gray-900">
                              {item.details}
                            </td>
                            <td className="whitespace-nowrap px-6 py-4 text-sm font-light text-gray-900">
                              {item.link}
                            </td>
                            <td className="whitespace-nowrap px-6 py-4 text-sm font-light gap-1 flex flex-wrap text-gray-900">
                              <button
                                data-bs-toggle="modal"
                                data-bs-target="#exampleModalEdit"
                                className="bg-primary-green rounded-full p-1 px-2 text-white"
                                onClick={() => {
                                  setBkId(item.id);
                                }}
                              >
                                View/Edit
                              </button>

                              <EditModal bookmarkId={bkId} change={setDel} />

                              <button
                                onClick={() => deleteBookmark(item.id)}
                                className="bg-primary-green rounded-full p-1 px-2 text-white"
                              >
                                Delete
                              </button>
                            </td>
                            <td className="whitespace-nowrap px-6 py-4 text-sm font-light text-gray-900">
                              {item.is_active === true ? (
                                <p className="bg-primary-red rounded-full p-1 px-2 text-white">
                                  show
                                </p>
                              ) : (
                                <p className="bg-primary-red rounded-full p-1 px-2 text-white">
                                  Hidden
                                </p>
                              )}
                            </td>
                          </tr>
                        ))}
                      </>
                    ) : (
                      <>
                        <div>No Data Found</div>
                      </>
                    )}
                  </tbody>
                </table>
                <div className="bg-primary-green ml-10 mt-3 inline-flex gap-2 rounded-md px-5 py-3 font-bold text-white">
                  <a href="">Print</a>
                </div>
                <div className="bg-primary-blue ml-10 mt-3 inline-flex gap-2 rounded-md px-5 py-3 font-bold text-white">
                {viewMore ? <button onClick={() => setViewMore(false)}>View More</button> :
                        <button onClick={()=> setViewMore(true)}>View Less</button>
                    }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* end table */}
    </div>
  );
};

export default BookmarkList;
